import { StoreInterface } from "../../models";

export const getAllUsers = (state: StoreInterface) => state?.users?.users;
export const getDeleteUserId = (state: StoreInterface) =>
  state?.users?.deleteUserId;
export const getLastTeamsUsersManagers = (state: StoreInterface) =>
  state?.users?.lastTeamsUsersManagersId;
export const getUserById = (state: StoreInterface) =>
    state?.users?.user;